/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {
  AfterViewInit,
  Component,
  effect,
  ElementRef,
  input,
  output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { CalendarResourcesDay, CommonUtils } from '@infodata-group/inf-commons';
import dayjs from 'dayjs';
import { NgClass, NgStyle } from '@angular/common';

@Component({
  selector: 'infl-calendar-days',
  templateUrl: './calendar-days.component.html',
  styleUrls: ['./calendar-days.component.scss'],
  standalone: true,
  imports: [NgClass, NgStyle],
})
export class CalendarDaysComponent implements AfterViewInit {
  public date = input<Date>();
  public withGroup = input(false);
  public grayedCells = input<Date[]>();
  public canDrag = input(false);
  public canResize = input(false);

  public loadSections = output<CalendarResourcesDay[]>();
  public scroll = output<number>();

  @ViewChildren('days') days: QueryList<ElementRef<HTMLDivElement>>;

  public sections: CalendarResourcesDay[] = [];
  private isLoaded = false;

  constructor() {
    effect(() => {
      if (this.date()) {
        this.initSections();
        if (this.isLoaded) {
          this.scrollToToday();
        }
      }
    });
  }

  ngAfterViewInit(): void {
    this.scrollToToday();
    this.isLoaded = true;
  }

  private scrollToToday() {
    const today = this.sections.find((section) => section.isCurrentDay);
    if (!today) {
      this.scroll.emit(0);
      return;
    }
    const indexToday = this.sections.indexOf(today);
    const currentHeight = this.days
      .toArray()
      .slice(0, indexToday)
      .reduce((height, day) => {
        return height + day.nativeElement.offsetHeight;
      }, 0);
    this.scroll.emit(currentHeight);
  }

  private initSections() {
    let date = dayjs(this.date()).startOf('month');
    const month = date.get('month');
    this.sections = [];
    while (date.month() === month) {
      const section = new CalendarResourcesDay(date.toDate());
      this.sections.push(section);
      if (
        this.grayedCells().find((grayedCell) =>
          CommonUtils.compareDate(grayedCell, date.toDate()),
        )
      ) {
        section.grayed = true;
      }
      date = dayjs(date).add(1, 'd');
    }
    this.loadSections.emit(this.sections);
  }
}
